import { ITrackingFact } from './../../../Core/@types/global/tracking';
import { ServiceLayerClient } from './../ServiceLayerClient';
import { Async } from '../../../../Templates/Core/JS/Components/Async';
import trackingOperator from './TrackingOperator';
import trackingDataHandler from './TrackingDataHandler';
import dataHandler from './TrackingDataHandler';

// TODO: SP Tracker - Once tracking of views & impressions is no longer needed, this class can be removed.
class TrackingViewsImpressionsHandler {
	public factsHistory: string[] = [];
	private reload = false;

	public collect(): void {
		// Find location: only the first location element and ignore all others
		// It's okay if none is set, gatherLocation handles this.

		// Check if we are on a search page and save the search data if this is the case.
		if (document.querySelector('.TrackingSearchValue')) {
			this.saveSearchData();
		}

		// Collect facts.
		const facts: ITrackingFact[] = [];
		const trackingEvents = Array.from(document.getElementsByClassName('TrackingEvent')) as HTMLElement[];
		trackingEvents.forEach((element) => {
			// On reload only gather TrackingRetrigger elements.
			if (this.reload && !element.classList.contains('TrackingRetrigger')) return;

			const factDetails = trackingOperator.constructFactDetailsForViewsAndImpressions(element);
			if (!factDetails || this.areFactDetailsAlreadyIncluded(facts, factDetails)) {
				return;
			}

			facts.push(factDetails);
		});

		// Send the facts.
		if (facts.length > 0) {
			this.send(facts);
		}

		window.dispatchEvent(new CustomEvent('trackingready'));
	}

	public saveSearchData(): void {
		const search = document.querySelector('.TrackingSearchValue') as HTMLElement;

		const searchData = search?.dataset?.search;
		if (!search || !searchData?.length || searchData.length <= 0) {
			return;
		}

		const data = trackingDataHandler.retrieveTrackingDetails();
		if (data === null) {
			return;
		}

		data.search = searchData;
		trackingDataHandler.storeTrackingDetails(data);
	}

	public send(facts: ITrackingFact[], callback?: () => void): string | null | void {
		const userDetails = trackingOperator.constructUserDetailsForViewsAndImpressions();
		const locationDetails = dataHandler.retrieveLocationDetailsBasedOnTrackingLocationElement();
		const details = {
			l: locationDetails,
			s: dataHandler.retrieveTrackingDetailsSearch(),
			u: userDetails,
			f: facts
		};

		let data = JSON.stringify(details);
		if (data === null) {
			return null;
		}

		const trackData = trackingDataHandler.retrieveTrackingDetails();
		if (trackData === null) {
			return null;
		}

		const tap = trackData.tap_groups;

		const anyWindow = window as any;
		const unsupportedIE = window.navigator.appName === 'Netscape' && anyWindow.navigator.msPointerEnabled;
		this.factsHistory.push(data);

		if (
			!unsupportedIE &&
			('withCredentials' in new XMLHttpRequest() || typeof anyWindow.XDomainRequest != 'undefined')
		) {
			// Use CORS.
			const rHeaders = new Headers();
			rHeaders.append('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');

			const url = (anyWindow.Meta.sl_external_url as string) + 'track/facts/';
			fetch(url, {
				method: 'post',
				mode: 'cors',
				credentials: 'include',
				headers: rHeaders,
				body: ServiceLayerClient.parseBody({
					facts: data,
					taps: tap
				})
			})
				.then(() => {
					if (!callback || typeof callback !== 'function') {
						return;
					}

					callback();
				})
				.catch((e) => {
					// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-argument
					console.error('Tracking.send: ' + (e as Error).toString(), e);
				});
		} else {
			// When using the pixel tracking logic, Base64 encode the data.
			if (window.Loot) {
				data = btoa(JSON.stringify(JSON.parse(data)));
			}

			// Load the tracking pixel.
			const dataObj = { facts: data, taps: tap } as any;
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
			const queryString = Object.keys(dataObj)
				.map((param) => {
					return `${param}=${dataObj[param]}`;
				})
				.join('&');

			Async.image(`${anyWindow.Meta.sl_external_url}track/pixel/?${queryString}`);
		}

		// To send payload into the Snowplow pipeline:
		window.dispatchEvent(new CustomEvent('factsSent', { detail: facts }));
	}

	public sendSet(elements: HTMLElement[]): void {
		const facts = [];

		// eslint-disable-next-line @typescript-eslint/prefer-for-of
		for (let i = 0; i < elements.length; i++) {
			const obj = elements[i];

			const fact = trackingOperator.constructFactDetailsForViewsAndImpressions(obj);
			if (fact !== null) {
				facts.push(fact);
			}
		}

		this.send(facts);
	}

	public checkReloadState(): void {
		const url = window.location.toString();
		const data = trackingDataHandler.retrieveTrackingDetails();
		if (data === null) return;

		if (data.previousPage && data.previousPage === url) {
			this.reload = true;
		} else {
			this.reload = false;
		}
	}

	private areFactDetailsAlreadyIncluded(existingFactDetails: ITrackingFact[], newFact: ITrackingFact): boolean {
		const matchingFactDetails = existingFactDetails.find((existingFact) => {
			return (
				existingFact.a === newFact?.a &&
				existingFact.t === newFact?.t &&
				existingFact.i === newFact?.i &&
				existingFact.l === newFact?.l
			);
		});
		return matchingFactDetails !== undefined;
	}
}

export default new TrackingViewsImpressionsHandler();
